import React from 'react'

import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'
import useViewport from '../../modules/viewport/useViewport'

import { ActionType, IAction } from '../../actions/types'

import style from './style.module.scss'

export interface IRedirectMessageProps {
  action: IAction
}

const RedirectMessage = React.memo<IRedirectMessageProps>(
  ({ action }) => {
    const { t } = useInterfaceLocale()
    const viewport = useViewport()

    return ActionType.END === action.action && action.redirect_url?.length ? (
      <p
        data-testid="SW-NavigationPanel-Redirect-Text"
        className={`${style.RedirectMessage} ${viewport.mobile ? style.mobile : ''}`}
        dangerouslySetInnerHTML={{ __html: t('preview', 'redirect', 'text').replace('{url}', action.redirect_url) }}
      />
    ) : null
  },
  () => true
)

RedirectMessage.displayName = 'RedirectMessage'

export default RedirectMessage
